var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.componentName, {
    tag: "component",
    attrs: {
      height: _vm.dimension,
      width: _vm.dimension,
      "icon-color": _vm.iconColor,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }